export const paypal = {
    PAYPAL_KEY: process.env.REACT_APP_PAYPAL_KEY,
}